import React, { useState, useEffect } from 'react';
import styles from '../../styles/Roommates/GroupMembers.module.css';
import StatusBadge from '../common/StatusBadge';

const API_BASE_URL = import.meta.env.VITE_API_URL;


const GroupStatusIndicator = ({ groupStatus }) => {
  const statusConfig = {
    userPending: { text: "Action Required: Your group is not eligible", status: "userPending" },
    miloPending: { text: "Processing: MILO processing docs", status: "processing" },
    ready: { text: "Your group is ready!", status: "completed" }
  };

  const { text, status } = statusConfig[groupStatus];
  return <div className={styles.groupStatus}><StatusBadge status={status} text={text} /></div>;
};

const determineGroupStatus = (members) => {
  const hasUserPending = members.some(m => 
    ['creditScore', 'income'].some(field => m[field] === 'Not Created') ||
    (m.role !== 'Cosigner' && m.backgroundCheck === 'Not Created')
  );
  const hasMiloPending = members.some(m => 
    ['creditScore', 'income', 'backgroundCheck'].some(field => m[field] === 'Processing')
  );
  return hasUserPending ? 'userPending' : hasMiloPending ? 'miloPending' : 'ready';
};

const statusBadge = {
  'Not Created': { icon: '⚠️', class: styles.userPending, text: 'Pending' },
  'Processing': { icon: '🔄', class: styles.processing, text: 'Processing' },
  'Completed': { icon: '✅', class: styles.completed, text: 'Completed' },
};

const GroupMembers = ({ groupId }) => {
  const [members, setMembers] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE_URL}/roommates/group-members/${groupId}`)
      .then(res => res.json())
      .then(data => setMembers(data));
  }, [groupId]);

  const groupStatus = determineGroupStatus(members);

  return (
    <div className={styles.groupMembers}>
      <div className={styles.groupHeader} onClick={() => setIsOpen(!isOpen)}>
        <h3>Your Search Group {isOpen ? '▴' : '▾'}</h3>
        <div className={styles.statusIndicator}>
          <GroupStatusIndicator groupStatus={groupStatus} />
        </div>
      </div>

      {isOpen && members.length > 0 && (
        <table className={styles.memberTable}>
          <thead>
            <tr>
              <th>Member</th>
              <th>Role</th>
              <th>Credit Score</th>
              <th>Income</th>
              <th>Background Check</th>
            </tr>
          </thead>
          <tbody>
            {members.map((member, idx) => (
              <tr key={idx}>
                <td>
                  <div className={styles.avatar}>{member.initials}</div>
                  {member.name}
                </td>
                <td>{member.role}</td>
                {['creditScore', 'income', 'backgroundCheck'].map(field => (
                  <td key={field}>
                    <span className={`${styles.badge} ${statusBadge[member[field]].class}`}>
                      {statusBadge[member[field]].icon} {statusBadge[member[field]].text}
                    </span>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {isOpen && members.length === 0 && <div>No roommates in your group yet.</div>}
    </div>
  );
};

export default GroupMembers;
